<template>
  <div class="app-container">
    <el-tabs v-model="active" @tab-click="handleClick" type="card" class="cardTabs">
      <el-tab-pane label="周报表" name="0">
        <list ref="list" />
      </el-tab-pane>
      <el-tab-pane label="月报表" name="1">
        <list ref="list2" :type="1" />
      </el-tab-pane>
      <el-tab-pane label="学期报表" name="2">
        <list2 ref="list3" :type="2" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import curdMixins from "@/mixins/curd";
import list from "@/components/at/wjrecord/list";
import list2 from "@/components/at/wjrecord/list2";

export default {
  name: "wjrecord",
  mixins: [curdMixins],
  components: {
    list,
    list2,
  },
  data() {
    return {
      active: "0",
      isMB: this.$store.state.isMB,
    };
  },
  methods: {
    handleClick() {
      this.reload();
    },
    reload() {
      if (this.active == "0") this.$refs.list.query();
      if (this.active == "1") this.$refs.list2.query();
      if (this.active == "2") this.$refs.list3.query();
    },
  }
};
</script>